define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-style",
	"dijit/form/ComboButton",
	"dijit/MenuItem",
	"csi/_base/underscore",
	"csi/locale",
	"csi/widget/Menu",
	"../SvgShapePalette",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(declare,lang,domClass,style,ComboButton,MenuItem,_,locale,Menu,SvgShapePalette,_Plugin,PluginFactory, util) {

	return PluginFactory.declare([ComboButton, _Plugin], {
		"class": "csi-button-toggle csi-single-toggle",
		bHideWhenDisabled: false,
		materialIcon: "crop",
		title: "CanvasCropImage",
		pluginName: "CanvasScaleImage",

		startup: function() {
			this.dropDown = new Menu({});
			
			this.dropDown.addChild(new MenuItem({
				label: locale.resource("CanvasScaleImageToFill"),
				onClick: () => this.editor.scaleImageToFrame("fill")
			}));
			this.dropDown.addChild(new MenuItem({
				label: locale.resource("CanvasScaleImageToFit"),
				onClick: () => this.editor.scaleImageToFrame("fit")
			}));
			this.dropDown.addChild(new MenuItem({
				label: locale.resource("CanvasScaleImageToOriginal"),
				onClick: () => this.editor.scaleImageToFrame("original")
			}));

			this.inherited(arguments);
		},

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set('checked', this.editor.isEditCurveCanvasMode() || this.editor.isEditPictureCanvasMode());

			return (shapes.length > 0) && this.editor.canvasApp.selection.isPicture(shapes[0]);
		},

		/**
		 * Edit selected page object.
		 */
		onClick: function() {
			this.editor.editPageObject();
		}
	});
});